import { Box } from "@mui/material";
import { ReactNode } from "react";

type FieldWrapperProps = {
  children: ReactNode;
  bgColor?: string; // background color override
  variant?: "outlined" | "filled" | "none"; // style variants
};

export const FieldWrapper = ({ children, bgColor, variant = "filled" }: FieldWrapperProps) => {
  let styles: any = {
    width: "100%",
  };

  if (variant === "filled") {
    styles.backgroundColor = bgColor || "#e0edff";
  } else if (variant === "outlined") {
    styles.border = "1px solid #0D628D";
    styles.backgroundColor = bgColor || "transparent";
  }

  return <Box sx={styles}>{children}</Box>;
};